"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledControlWrapper = exports.StyledControlNestedContent = exports.StyledControlLabel = exports.StyledControlInputWrapper = exports.StyledControlInput = exports.StyledControlHint = exports.StyledControlError = exports.Control = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _tokens = require("../../../../tokens");
var _hooks = require("../../../../internal/hooks");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledControlWrapper = exports.StyledControlWrapper = _styledComponents.default.div.withConfig({
  displayName: "StyledControlWrapper",
  componentId: "sc-1iiq37b-0"
})(["", ""], _ref => {
  let {
    $hasLabel
  } = _ref;
  return $hasLabel ? `
    margin: ${_tokens.GTR.M} 0;
    ` : `
    position: relative;
  `;
});
const StyledControlLabel = exports.StyledControlLabel = _styledComponents.default.label.withConfig({
  displayName: "StyledControlLabel",
  componentId: "sc-1iiq37b-1"
})(["position:relative;display:flex;align-items:center;touch-action:manipulation;", ""], _ref2 => {
  let {
    $disabled
  } = _ref2;
  return !$disabled && `
    label& {
      cursor: pointer;
      user-select: none;
    }
  `;
});
const StyledControlInputWrapper = exports.StyledControlInputWrapper = _styledComponents.default.span.withConfig({
  displayName: "StyledControlInputWrapper",
  componentId: "sc-1iiq37b-2"
})(["position:relative;display:inline-block;margin-right:", ";", ""], _tokens.GTR.S, _ref3 => {
  let {
    $inputWidth
  } = _ref3;
  return `
    flex: 0 0 ${$inputWidth}px;
    width: ${$inputWidth}px;
  `;
});
const TAP_BUFFER = '4px';
const StyledControlInput = exports.StyledControlInput = _styledComponents.default.input.withConfig({
  displayName: "StyledControlInput",
  componentId: "sc-1iiq37b-3"
})(["position:absolute;top:-", ";left:-", ";width:calc(100% + 2 * ", ");height:calc(100% + 2 * ", ");opacity:0;cursor:pointer;"], TAP_BUFFER, TAP_BUFFER, TAP_BUFFER, TAP_BUFFER);
const StyledControlHint = exports.StyledControlHint = _styledComponents.default.div.withConfig({
  displayName: "StyledControlHint",
  componentId: "sc-1iiq37b-4"
})(["font-size:", ";", ""], _tokens.FONT.SIZE.S, _ref4 => {
  let {
    $inputWidth
  } = _ref4;
  return $inputWidth ? `
        padding-left: ${_tokens.GTR.S};
        margin-left: ${$inputWidth}px;
      ` : `
        position: relative;
        top: -${_tokens.GTR.XS};
        margin-left: ${_tokens.GTR.S};

        && + * {
          margin-top: 0;
        }
  `;
});
const INDENT_WIDTH = 4;
const StyledControlNestedContent = exports.StyledControlNestedContent = _styledComponents.default.div.withConfig({
  displayName: "StyledControlNestedContent",
  componentId: "sc-1iiq37b-5"
})(["margin:", " 0 ", ";border-left:", "px solid ", ";", " > *:first-child{margin-top:0;}> *:last-child{margin-bottom:0;}"], _tokens.GTR.XS, _ref5 => {
  let {
    $error
  } = _ref5;
  return $error ? _tokens.GTR.XS : _tokens.GTR.S;
}, INDENT_WIDTH, _tokens.COLOR.GREY.MEDIUM, _ref6 => {
  let {
    $inputWidth
  } = _ref6;
  const spacing = ($inputWidth - INDENT_WIDTH) / 2;
  return `
      margin-left: ${spacing}px;
      padding-left: ${spacing}px;
    `;
});
const StyledControlError = exports.StyledControlError = _styledComponents.default.div.withConfig({
  displayName: "StyledControlError",
  componentId: "sc-1iiq37b-6"
})(["margin-top:", ";font-size:", ";color:", ";"], _tokens.GTR.XS, _tokens.FONT.SIZE.S, _tokens.COLOR.STATE.ERROR);
// eslint-disable-next-line react/display-name
const Control = exports.Control = /*#__PURE__*/_react.default.forwardRef((_ref7, forwardedRef) => {
  let {
    checked,
    label,
    hint,
    error,
    nestedContent,
    inputWidth,
    disabled,
    className,
    labelAttributes,
    children,
    id: idProp,
    ...props
  } = _ref7;
  const id = idProp || (0, _hooks.useUniqueId)();
  const hintId = `hint-${id}`;
  const labelId = `label-${id}`;
  const showNestedContent = nestedContent && checked;
  return /*#__PURE__*/_react.default.createElement(StyledControlWrapper, {
    className: className,
    $hasLabel: !!label
  }, label ? /*#__PURE__*/_react.default.createElement(StyledControlLabel, _extends({
    as: typeof label !== 'string' ? 'div' : 'label'
  }, labelAttributes, {
    $disabled: !!disabled,
    id: labelId
  }), /*#__PURE__*/_react.default.createElement(StyledControlInputWrapper, {
    $inputWidth: inputWidth
  }, /*#__PURE__*/_react.default.createElement(StyledControlInput, _extends({
    id: id,
    checked: checked,
    disabled: disabled,
    "aria-labelledby": labelId,
    "aria-describedby": hint ? hintId : undefined,
    ref: forwardedRef
  }, props)), children), label) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledControlInput, _extends({
    id: id,
    checked: checked,
    disabled: disabled,
    "aria-describedby": hint ? hintId : undefined,
    ref: forwardedRef
  }, props)), children), hint && !showNestedContent && /*#__PURE__*/_react.default.createElement(StyledControlHint, {
    id: hintId,
    $inputWidth: inputWidth
  }, hint), showNestedContent && /*#__PURE__*/_react.default.createElement(StyledControlNestedContent, {
    $inputWidth: inputWidth,
    $error: !!error,
    "aria-labelledby": labelId
  }, hint && /*#__PURE__*/_react.default.createElement(StyledControlHint, {
    id: hintId
  }, hint), nestedContent), error && /*#__PURE__*/_react.default.createElement(StyledControlError, null, error));
});